import apiConfig from "constants/apiConfig";
import { CreatorTag } from "types/creators";
import axiosClient from "utils/axiosClient";

export const fetchCreatorTags = async (hubId: string): Promise<CreatorTag[]> => {
    const response = await axiosClient.get(apiConfig.FETCH_CREATOR_TAGS.url.replace('<hubId>', hubId));
    return response.data.items;
}

export const searchCreatorTags = async (hubId: string, q: string): Promise<string[]> => {
    const response = await axiosClient.get(apiConfig.SEARCH_CREATOR_TAGS.url.replace('<hubId>', hubId), {
        params: {
            q,
        },
    });
    return response.data.results;
}

export const createCreatorTag = async (hubId: string, name: string): Promise<CreatorTag> => {
    const response = await axiosClient.post(apiConfig.CREATE_CREATOR_TAG.url.replace('<hubId>', hubId), {
        name,
    });
    return response.data;
}

export const updateCreatorTag = async (hubId: string, creatorTagId: number, name: string): Promise<CreatorTag> => {
    const response = await axiosClient.put(apiConfig.UPDATE_CREATOR_TAG.url.replace('<hubId>', hubId).replace('<creatorTagId>', String(creatorTagId)), {
        name,
    });
    return response.data;
}

export const deleteCreatorTag = async (hubId: string, creatorTagId: number): Promise<void> => {
    await axiosClient.delete(apiConfig.DELETE_CREATOR_TAG.url.replace('<hubId>', hubId).replace('<creatorTagId>', String(creatorTagId)));
}